var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3535_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C5.1544e-07 8.9543 8.9543 5.15406e-07 20 0ZM8.81934 31.667H13.8662V15.3701H8.81934V31.667ZM26.8467 14.8721C23.4058 14.8721 21.9481 17.5388 21.9336 17.5654V15.3701H17.0928V31.667H21.9336V23.1123C21.9336 20.8202 22.9883 19.4561 25.0078 19.4561C26.8642 19.4561 27.7559 20.7669 27.7559 23.1123V31.667H32.7783V21.3486C32.7783 16.9832 30.3032 14.8721 26.8467 14.8721ZM11.3184 7.22266C9.66963 7.22266 8.33398 8.56884 8.33398 10.2295C8.33408 11.8901 9.66969 13.2363 11.3184 13.2363C12.967 13.2363 14.3017 11.89 14.3018 10.2295C14.3018 8.56889 12.967 7.22272 11.3184 7.22266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3535_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.831f83449964397a60456bbd0ea4a2ca.svg";
export { ForwardRef as ReactComponent };